import type { TypePolicies } from '../../../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  Account: {
    fields: {
      resourceControlPolicies: {
        /**
         * The `ResourceControlPolicy` type is non-normalized, for now. This makes
         * sense because There Can Be Only One (policy per account).
         */
        merge: true,
      },
    },
  },
};
